import * as r from "react";
import $, { forwardRef as we, useMemo as he } from "react";
import { s as Oe, a as xe, b as Ne, c as Se, i as re, R as Pe } from "./LeftOutlined-Cz5Dhn8F.mjs";
import { O as Ee, Q as pe, F as me, z as Re, i as ze, q as U, o as De, f as je, g as Ie, m as Ae, b as Me, Y as le, u as Q, a as oe, s as Te, n as _e, j as Ve } from "./index-CjjiqU7h.mjs";
import { T as Be } from "./index-z2Yki-8P.mjs";
import { K as fe } from "./motion-P3tHGbiP.mjs";
import { a as Le, u as Fe } from "./useCSSVarCls--o7XUl-F.mjs";
import { o as He } from "./omit-B_u6A-HL.mjs";
import { u as We, z as Xe } from "./Portal-CYsTveh8.mjs";
import { g as ke, b as Ge, a as Ue, c as Ye } from "./index-BP092b3A.mjs";
import { g as qe } from "./PurePanel-Bpm-3pHm.mjs";
import { c as Ke } from "./reactNode-CwSzDQK_.mjs";
import { M as Ze, O as Qe, E as Je } from "./index-D_u8yzLg.mjs";
import { i as se } from "./move-CodNxzZd.mjs";
import { i as et } from "./zoom-DWyN4gat.mjs";
import { B as ce } from "./button-BIXC-Zd-.mjs";
import { t as tt } from "./toArray-C1Af_up9.mjs";
import { i as de, a as ue } from "./style-ClHoikNh.mjs";
import { C as nt, b as ot, a as at } from "./Compact-8zmhZt2C.mjs";
var it = fe.ESC, rt = fe.TAB;
function lt(e) {
  var o = e.visible, n = e.triggerRef, a = e.onVisibleChange, i = e.autoFocus, l = e.overlayRef, t = r.useRef(!1), s = function() {
    if (o) {
      var u, d;
      (u = n.current) === null || u === void 0 || (d = u.focus) === null || d === void 0 || d.call(u), a == null || a(!1);
    }
  }, m = function() {
    var u;
    return (u = l.current) !== null && u !== void 0 && u.focus ? (l.current.focus(), t.current = !0, !0) : !1;
  }, g = function(u) {
    switch (u.keyCode) {
      case it:
        s();
        break;
      case rt: {
        var d = !1;
        t.current || (d = m()), d ? u.preventDefault() : s();
        break;
      }
    }
  };
  r.useEffect(function() {
    return o ? (window.addEventListener("keydown", g), i && Ee(m, 3), function() {
      window.removeEventListener("keydown", g), t.current = !1;
    }) : function() {
      t.current = !1;
    };
  }, [o]);
}
var st = /* @__PURE__ */ we(function(e, o) {
  var n = e.overlay, a = e.arrow, i = e.prefixCls, l = he(function() {
    var s;
    return typeof n == "function" ? s = n() : s = n, s;
  }, [n]), t = pe(o, l == null ? void 0 : l.ref);
  return /* @__PURE__ */ $.createElement($.Fragment, null, a && /* @__PURE__ */ $.createElement("div", {
    className: "".concat(i, "-arrow")
  }), /* @__PURE__ */ $.cloneElement(l, {
    ref: me(l) ? t : void 0
  }));
}), J = {
  adjustX: 1,
  adjustY: 1
}, ee = [0, 0], ct = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: J,
    offset: [0, -4],
    targetOffset: ee
  },
  top: {
    points: ["bc", "tc"],
    overflow: J,
    offset: [0, -4],
    targetOffset: ee
  },
  topRight: {
    points: ["br", "tr"],
    overflow: J,
    offset: [0, -4],
    targetOffset: ee
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: J,
    offset: [0, 4],
    targetOffset: ee
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: J,
    offset: [0, 4],
    targetOffset: ee
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: J,
    offset: [0, 4],
    targetOffset: ee
  }
}, dt = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function ut(e, o) {
  var n, a = e.arrow, i = a === void 0 ? !1 : a, l = e.prefixCls, t = l === void 0 ? "rc-dropdown" : l, s = e.transitionName, m = e.animation, g = e.align, b = e.placement, u = b === void 0 ? "bottomLeft" : b, d = e.placements, C = d === void 0 ? ct : d, f = e.getPopupContainer, S = e.showAction, V = e.hideAction, Y = e.overlayClassName, B = e.overlayStyle, L = e.visible, p = e.trigger, w = p === void 0 ? ["hover"] : p, P = e.autoFocus, F = e.overlay, h = e.children, E = e.onVisibleChange, R = Re(e, dt), z = $.useState(), H = ze(z, 2), y = H[0], v = H[1], I = "visible" in e ? L : y, X = $.useRef(null), k = $.useRef(null), A = $.useRef(null);
  $.useImperativeHandle(o, function() {
    return X.current;
  });
  var D = function(N) {
    v(N), E == null || E(N);
  };
  lt({
    visible: I,
    triggerRef: A,
    onVisibleChange: D,
    autoFocus: P,
    overlayRef: k
  });
  var O = function(N) {
    var Z = e.onOverlayClick;
    v(!1), Z && Z(N);
  }, G = function() {
    return /* @__PURE__ */ $.createElement(st, {
      ref: k,
      overlay: F,
      prefixCls: t,
      arrow: i
    });
  }, x = function() {
    return typeof F == "function" ? G : G();
  }, j = function() {
    var N = e.minOverlayWidthMatchTrigger, Z = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? N : !Z;
  }, W = function() {
    var N = e.openClassName;
    return N !== void 0 ? N : "".concat(t, "-open");
  }, _ = /* @__PURE__ */ $.cloneElement(h, {
    className: U((n = h.props) === null || n === void 0 ? void 0 : n.className, I && W()),
    ref: me(h) ? pe(A, h.ref) : void 0
  }), M = V;
  return !M && w.indexOf("contextMenu") !== -1 && (M = ["click"]), /* @__PURE__ */ $.createElement(Be, De({
    builtinPlacements: C
  }, R, {
    prefixCls: t,
    ref: X,
    popupClassName: U(Y, je({}, "".concat(t, "-show-arrow"), i)),
    popupStyle: B,
    action: w,
    showAction: S,
    hideAction: M,
    popupPlacement: u,
    popupAlign: g,
    popupTransitionName: s,
    popupAnimation: m,
    popupVisible: I,
    stretch: j() ? "minWidth" : "",
    popup: x(),
    onPopupVisibleChange: D,
    onPopupClick: O,
    getPopupContainer: f
  }), _);
}
const pt = /* @__PURE__ */ $.forwardRef(ut), mt = (e) => {
  const {
    componentCls: o,
    menuCls: n,
    colorError: a,
    colorTextLightSolid: i
  } = e, l = `${n}-item`;
  return {
    [`${o}, ${o}-menu-submenu`]: {
      [`${n} ${l}`]: {
        [`&${l}-danger:not(${l}-disabled)`]: {
          color: a,
          "&:hover": {
            color: i,
            backgroundColor: a
          }
        }
      }
    }
  };
}, ft = mt, vt = (e) => {
  const {
    componentCls: o,
    menuCls: n,
    zIndexPopup: a,
    dropdownArrowDistance: i,
    sizePopupArrow: l,
    antCls: t,
    iconCls: s,
    motionDurationMid: m,
    paddingBlock: g,
    fontSize: b,
    dropdownEdgeChildPadding: u,
    colorTextDisabled: d,
    fontSizeIcon: C,
    controlPaddingHorizontal: f,
    colorBgElevated: S
  } = e;
  return [
    {
      [o]: {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: a,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(l).div(2).sub(i).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`&-trigger${t}-btn`]: {
          [`& > ${s}-down, & > ${t}-btn-icon > ${s}-down`]: {
            fontSize: C
          }
        },
        [`${o}-wrap`]: {
          position: "relative",
          [`${t}-btn > ${s}-down`]: {
            fontSize: C
          },
          [`${s}-down::before`]: {
            transition: `transform ${m}`
          }
        },
        [`${o}-wrap-open`]: {
          [`${s}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${t}-slide-down-enter${t}-slide-down-enter-active${o}-placement-bottomLeft,
          &${t}-slide-down-appear${t}-slide-down-appear-active${o}-placement-bottomLeft,
          &${t}-slide-down-enter${t}-slide-down-enter-active${o}-placement-bottom,
          &${t}-slide-down-appear${t}-slide-down-appear-active${o}-placement-bottom,
          &${t}-slide-down-enter${t}-slide-down-enter-active${o}-placement-bottomRight,
          &${t}-slide-down-appear${t}-slide-down-appear-active${o}-placement-bottomRight`]: {
          animationName: Oe
        },
        [`&${t}-slide-up-enter${t}-slide-up-enter-active${o}-placement-topLeft,
          &${t}-slide-up-appear${t}-slide-up-appear-active${o}-placement-topLeft,
          &${t}-slide-up-enter${t}-slide-up-enter-active${o}-placement-top,
          &${t}-slide-up-appear${t}-slide-up-appear-active${o}-placement-top,
          &${t}-slide-up-enter${t}-slide-up-enter-active${o}-placement-topRight,
          &${t}-slide-up-appear${t}-slide-up-appear-active${o}-placement-topRight`]: {
          animationName: xe
        },
        [`&${t}-slide-down-leave${t}-slide-down-leave-active${o}-placement-bottomLeft,
          &${t}-slide-down-leave${t}-slide-down-leave-active${o}-placement-bottom,
          &${t}-slide-down-leave${t}-slide-down-leave-active${o}-placement-bottomRight`]: {
          animationName: Ne
        },
        [`&${t}-slide-up-leave${t}-slide-up-leave-active${o}-placement-topLeft,
          &${t}-slide-up-leave${t}-slide-up-leave-active${o}-placement-top,
          &${t}-slide-up-leave${t}-slide-up-leave-active${o}-placement-topRight`]: {
          animationName: Se
        }
      }
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    ke(e, S, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${o} ${n}`]: {
        position: "relative",
        margin: 0
      },
      [`${n}-submenu-popup`]: {
        position: "absolute",
        zIndex: a,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${o}, ${o}-menu-submenu`]: Object.assign(Object.assign({}, Me(e)), {
        [n]: Object.assign(Object.assign({
          padding: u,
          listStyleType: "none",
          backgroundColor: S,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, le(e)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${n}-item-group-title`]: {
            padding: `${Q(g)} ${Q(f)}`,
            color: e.colorTextDescription,
            transition: `all ${m}`
          },
          // ======================= Item Content =======================
          [`${n}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${n}-item-icon`]: {
            minWidth: b,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${n}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${m}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${n}-item, ${n}-submenu-title`]: Object.assign(Object.assign({
            clear: "both",
            margin: 0,
            padding: `${Q(g)} ${Q(f)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: b,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${m}`,
            borderRadius: e.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, le(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: d,
              cursor: "not-allowed",
              "&:hover": {
                color: d,
                backgroundColor: S,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${Q(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${o}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${o}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorTextDescription,
                fontSize: C,
                fontStyle: "normal"
              }
            }
          }),
          [`${n}-item-group-list`]: {
            margin: `0 ${Q(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${n}-submenu-title`]: {
            paddingInlineEnd: e.calc(f).add(e.fontSizeSM).equal()
          },
          [`${n}-submenu-vertical`]: {
            position: "relative"
          },
          [`${n}-submenu${n}-submenu-disabled ${o}-menu-submenu-title`]: {
            [`&, ${o}-menu-submenu-arrow-icon`]: {
              color: d,
              backgroundColor: S,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${n}-submenu-selected ${o}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      })
    },
    // Follow code may reuse in other components
    [re(e, "slide-up"), re(e, "slide-down"), se(e, "move-up"), se(e, "move-down"), et(e, "zoom-big")]
  ];
}, gt = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, Ge({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), Ue(e)), bt = Ie("Dropdown", (e) => {
  const {
    marginXXS: o,
    sizePopupArrow: n,
    paddingXXS: a,
    componentCls: i
  } = e, l = Ae(e, {
    menuCls: `${i}-menu`,
    dropdownArrowDistance: e.calc(n).div(2).add(o).equal(),
    dropdownEdgeChildPadding: a
  });
  return [vt(l), ft(l)];
}, gt, {
  resetStyle: !1
}), te = (e) => {
  var o;
  const {
    menu: n,
    arrow: a,
    prefixCls: i,
    children: l,
    trigger: t,
    disabled: s,
    dropdownRender: m,
    getPopupContainer: g,
    overlayClassName: b,
    rootClassName: u,
    overlayStyle: d,
    open: C,
    onOpenChange: f,
    // Deprecated
    visible: S,
    onVisibleChange: V,
    mouseEnterDelay: Y = 0.15,
    mouseLeaveDelay: B = 0.1,
    autoAdjustOverflow: L = !0,
    placement: p = "",
    overlay: w,
    transitionName: P
  } = e, {
    getPopupContainer: F,
    getPrefixCls: h,
    direction: E,
    dropdown: R
  } = r.useContext(oe), z = Te("Dropdown");
  process.env.NODE_ENV !== "production" && ([["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((c) => {
    let [q, K] = c;
    z.deprecated(!(q in e), q, K);
  }), z.deprecated(!("overlay" in e), "overlay", "menu"));
  const H = r.useMemo(() => {
    const c = h();
    return P !== void 0 ? P : p.includes("top") ? `${c}-slide-down` : `${c}-slide-up`;
  }, [h, p, P]), y = r.useMemo(() => p ? p.includes("Center") ? p.slice(0, p.indexOf("Center")) : p : E === "rtl" ? "bottomRight" : "bottomLeft", [p, E]);
  if (process.env.NODE_ENV !== "production") {
    if (p.includes("Center")) {
      const c = p.slice(0, p.indexOf("Center"));
      process.env.NODE_ENV !== "production" && z(!p.includes("Center"), "deprecated", `You are using '${p}' placement in Dropdown, which is deprecated. Try to use '${c}' instead.`);
    }
    [["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((c) => {
      let [q, K] = c;
      z.deprecated(!(q in e), q, K);
    });
  }
  const v = h("dropdown", i), I = Le(v), [X, k, A] = bt(v, I), [, D] = _e(), O = r.Children.only(l), G = Ke(O, {
    className: U(`${v}-trigger`, {
      [`${v}-rtl`]: E === "rtl"
    }, O.props.className),
    disabled: (o = O.props.disabled) !== null && o !== void 0 ? o : s
  }), x = s ? [] : t, j = !!(x != null && x.includes("contextMenu")), [W, _] = Fe(!1, {
    value: C ?? S
  }), M = Ve((c) => {
    f == null || f(c, {
      source: "trigger"
    }), V == null || V(c), _(c);
  }), T = U(b, u, k, A, I, R == null ? void 0 : R.className, {
    [`${v}-rtl`]: E === "rtl"
  }), N = Ye({
    arrowPointAtCenter: typeof a == "object" && a.pointAtCenter,
    autoAdjustOverflow: L,
    offset: D.marginXXS,
    arrowWidth: a ? D.sizePopupArrow : 0,
    borderRadius: D.borderRadius
  }), Z = r.useCallback(() => {
    n != null && n.selectable && (n != null && n.multiple) || (f == null || f(!1, {
      source: "menu"
    }), _(!1));
  }, [n == null ? void 0 : n.selectable, n == null ? void 0 : n.multiple]), ye = () => {
    let c;
    return n != null && n.items ? c = /* @__PURE__ */ r.createElement(Ze, Object.assign({}, n)) : typeof w == "function" ? c = w() : c = w, m && (c = m(c)), c = r.Children.only(typeof c == "string" ? /* @__PURE__ */ r.createElement("span", null, c) : c), /* @__PURE__ */ r.createElement(Qe, {
      prefixCls: `${v}-menu`,
      rootClassName: U(A, I),
      expandIcon: /* @__PURE__ */ r.createElement("span", {
        className: `${v}-menu-submenu-arrow`
      }, /* @__PURE__ */ r.createElement(Pe, {
        className: `${v}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: Z,
      validator: (q) => {
        let {
          mode: K
        } = q;
        process.env.NODE_ENV !== "production" && z(!K || K === "vertical", "usage", `mode="${K}" is not supported for Dropdown's Menu.`);
      }
    }, c);
  }, [ie, $e] = We("Dropdown", d == null ? void 0 : d.zIndex);
  let ne = /* @__PURE__ */ r.createElement(pt, Object.assign({
    alignPoint: j
  }, He(e, ["rootClassName"]), {
    mouseEnterDelay: Y,
    mouseLeaveDelay: B,
    visible: W,
    builtinPlacements: N,
    arrow: !!a,
    overlayClassName: T,
    prefixCls: v,
    getPopupContainer: g || F,
    transitionName: H,
    trigger: x,
    overlay: ye,
    placement: y,
    onVisibleChange: M,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, R == null ? void 0 : R.style), d), {
      zIndex: ie
    })
  }), G);
  return ie && (ne = /* @__PURE__ */ r.createElement(Xe.Provider, {
    value: $e
  }, ne)), X(ne);
};
function Ct(e) {
  return Object.assign(Object.assign({}, e), {
    align: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
}
const yt = qe(te, "dropdown", (e) => e, Ct), $t = (e) => /* @__PURE__ */ r.createElement(yt, Object.assign({}, e), /* @__PURE__ */ r.createElement("span", null));
te._InternalPanelDoNotUseOrYouWillBeFired = $t;
process.env.NODE_ENV !== "production" && (te.displayName = "Dropdown");
const ve = te, ge = /* @__PURE__ */ $.createContext({
  latestIndex: 0
}), wt = ge.Provider, ht = (e) => {
  let {
    className: o,
    index: n,
    children: a,
    split: i,
    style: l
  } = e;
  const {
    latestIndex: t
  } = r.useContext(ge);
  return a == null ? null : /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("div", {
    className: o,
    style: l
  }, a), n < t && i && /* @__PURE__ */ r.createElement("span", {
    className: `${o}-split`
  }, i));
}, Ot = ht;
var xt = function(e, o) {
  var n = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && o.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
      o.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (n[a[i]] = e[a[i]]);
  return n;
};
const Nt = /* @__PURE__ */ r.forwardRef((e, o) => {
  var n, a, i;
  const {
    getPrefixCls: l,
    space: t,
    direction: s
  } = r.useContext(oe), {
    size: m = (n = t == null ? void 0 : t.size) !== null && n !== void 0 ? n : "small",
    align: g,
    className: b,
    rootClassName: u,
    children: d,
    direction: C = "horizontal",
    prefixCls: f,
    split: S,
    style: V,
    wrap: Y = !1,
    classNames: B,
    styles: L
  } = e, p = xt(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [w, P] = Array.isArray(m) ? m : [m, m], F = de(P), h = de(w), E = ue(P), R = ue(w), z = tt(d, {
    keepEmpty: !0
  }), H = g === void 0 && C === "horizontal" ? "center" : g, y = l("space", f), [v, I, X] = ot(y), k = U(y, t == null ? void 0 : t.className, I, `${y}-${C}`, {
    [`${y}-rtl`]: s === "rtl",
    [`${y}-align-${H}`]: H,
    [`${y}-gap-row-${P}`]: F,
    [`${y}-gap-col-${w}`]: h
  }, b, u, X), A = U(`${y}-item`, (a = B == null ? void 0 : B.item) !== null && a !== void 0 ? a : (i = t == null ? void 0 : t.classNames) === null || i === void 0 ? void 0 : i.item);
  let D = 0;
  const O = z.map((j, W) => {
    var _, M;
    j != null && (D = W);
    const T = (j == null ? void 0 : j.key) || `${A}-${W}`;
    return /* @__PURE__ */ r.createElement(Ot, {
      className: A,
      key: T,
      index: W,
      split: S,
      style: (_ = L == null ? void 0 : L.item) !== null && _ !== void 0 ? _ : (M = t == null ? void 0 : t.styles) === null || M === void 0 ? void 0 : M.item
    }, j);
  }), G = r.useMemo(() => ({
    latestIndex: D
  }), [D]);
  if (z.length === 0)
    return null;
  const x = {};
  return Y && (x.flexWrap = "wrap"), !h && R && (x.columnGap = w), !F && E && (x.rowGap = P), v(/* @__PURE__ */ r.createElement("div", Object.assign({
    ref: o,
    className: k,
    style: Object.assign(Object.assign(Object.assign({}, x), t == null ? void 0 : t.style), V)
  }, p), /* @__PURE__ */ r.createElement(wt, {
    value: G
  }, O)));
}), ae = Nt;
ae.Compact = nt;
process.env.NODE_ENV !== "production" && (ae.displayName = "Space");
const St = ae;
var Pt = function(e, o) {
  var n = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && o.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
      o.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (n[a[i]] = e[a[i]]);
  return n;
};
const be = (e) => {
  const {
    getPopupContainer: o,
    getPrefixCls: n,
    direction: a
  } = r.useContext(oe), {
    prefixCls: i,
    type: l = "default",
    danger: t,
    disabled: s,
    loading: m,
    onClick: g,
    htmlType: b,
    children: u,
    className: d,
    menu: C,
    arrow: f,
    autoFocus: S,
    overlay: V,
    trigger: Y,
    align: B,
    open: L,
    onOpenChange: p,
    placement: w,
    getPopupContainer: P,
    href: F,
    icon: h = /* @__PURE__ */ r.createElement(Je, null),
    title: E,
    buttonsRender: R = (N) => N,
    mouseEnterDelay: z,
    mouseLeaveDelay: H,
    overlayClassName: y,
    overlayStyle: v,
    destroyPopupOnHide: I,
    dropdownRender: X
  } = e, k = Pt(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "dropdownRender"]), A = n("dropdown", i), D = `${A}-button`, O = {
    menu: C,
    arrow: f,
    autoFocus: S,
    align: B,
    disabled: s,
    trigger: s ? [] : Y,
    onOpenChange: p,
    getPopupContainer: P || o,
    mouseEnterDelay: z,
    mouseLeaveDelay: H,
    overlayClassName: y,
    overlayStyle: v,
    destroyPopupOnHide: I,
    dropdownRender: X
  }, {
    compactSize: G,
    compactItemClassnames: x
  } = at(A, a), j = U(D, x, d);
  "overlay" in e && (O.overlay = V), "open" in e && (O.open = L), "placement" in e ? O.placement = w : O.placement = a === "rtl" ? "bottomLeft" : "bottomRight";
  const W = /* @__PURE__ */ r.createElement(ce, {
    type: l,
    danger: t,
    disabled: s,
    loading: m,
    onClick: g,
    htmlType: b,
    href: F,
    title: E
  }, u), _ = /* @__PURE__ */ r.createElement(ce, {
    type: l,
    danger: t,
    icon: h
  }), [M, T] = R([W, _]);
  return /* @__PURE__ */ r.createElement(St.Compact, Object.assign({
    className: j,
    size: G,
    block: !0
  }, k), M, /* @__PURE__ */ r.createElement(ve, Object.assign({}, O), T));
};
be.__ANT_BUTTON = !0;
const Et = be, Ce = ve;
Ce.Button = Et;
const Ut = Ce;
export {
  Ut as D
};
//# sourceMappingURL=index-CgEpbOWw.mjs.map
